export default function debounce(func: (...args: any[]) => void, wait = 20): (...args: any[]) => void {
  let timeoutId: number;
  return (...args: any) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    // @ts-ignore
    timeoutId = setTimeout(() => func(...args), wait);
  };
}
